import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefundsService {

  // Search Order Panel
  private searchOrder = new BehaviorSubject<string>(null);
  public searchOrderStorage = this.searchOrder.asObservable();

  // LoadingTable
  private loadingTable = new BehaviorSubject<boolean>(null);
  public loadingTableStorage = this.loadingTable.asObservable();

  // Filters Order Panel
  private filtersOrder = new BehaviorSubject<any>(null);
  public filtersOrderStorage = this.filtersOrder.asObservable();

  constructor(private http: HttpClient) { }

  setLoadingTable(loadingTable: boolean) {
    this.loadingTable.next(loadingTable);
  }

  setFilters(dateFilter: any, priceFilter: any, statusFilter: any, methodFilter: any) {
    let filters = { dateFilter, priceFilter, statusFilter, methodFilter };
    let actualValue = this.filtersOrder.getValue() || { searchOrder: null, filterOrders: null };
    actualValue.filterOrders = filters;
    this.filtersOrder.next(actualValue);
  }

  setSearchOrder(searchText: string) {
    this.searchOrder.next(searchText);
    let actualValue = this.filtersOrder.getValue() || { searchOrder: null, filterOrders: null };
    actualValue.searchOrder = searchText;
    this.filtersOrder.next(actualValue);
  }


  getOrders(page: number = 1, order_by: string, order: string, date_start: string, date_end: string, price_start: number, price_end: number, id_status: any, id_channel: any, search: string) {
    let id_business = localStorage.getItem('id_business');
    let url = `${AppSettings.API_URI_V2}/company/${id_business}/transactions/list?page=${page}`;
    let addedFilter = false;
    if (order_by && order_by !== '' && order && order !== '') {
      addedFilter = true;
      url += `&order_by=${order_by}&order=${order.toUpperCase()}`;
    }
    if (date_start) {
      let parsedDate = date_start.split('-');
      date_start = `${parsedDate[2]}-${parsedDate[1]}-${parsedDate[0]}`;
      url += `&date_start=${date_start}`;
    }
    if (date_end) {
      let parsedDate = date_end.split('-');
      date_end = `${parsedDate[2]}-${parsedDate[1]}-${parsedDate[0]}`;
      url += `&date_end=${date_end}`;
    }
    if (price_start != null && price_start != undefined) {
      url += `&price_start=${price_start}`;
    }
    if (price_end != null && price_end != undefined) {
      url += `&price_end=${price_end}`;
    }
    if (id_status) {
      id_status.forEach((id) => {
        url += `&id_status[]=${id}`;
      });
    }
    if (id_channel) {
      id_channel.forEach((id) => {
        url += `&id_channel[]=${id}`;
      });
    }
    if (search != null && search != undefined && search != '') {
      url += `&search=${search}`;
    }
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getStatusOptions() {
    let id_business = localStorage.getItem('id_business');
    const url = `${AppSettings.API_URI_V2}/order/statuses`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    )
  }

  getChannelOptions() {
    const url = `${AppSettings.API_URI_V2}/order/sales-channels`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    )
  }

  getOrderByIdInvoice(id: any) {
    const url = `${AppSettings.API_URI_V2}/tpv/orders/${id}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    )
  }

  getOrderById(id: any) {
    const url = `${AppSettings.API_URI_V2}/orders/${id}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    )
  }

  getPrintUrl(idOrder: number) {
      const url = `${AppSettings.API_URI_V2}/orders/${idOrder}/tickets-urls`;
      return this.http.get<any>(url).pipe(
        map((data) => {
          return data
        }),
        catchError(err => { return throwError(() => err); })
      );
    }

  refundOrder(id: any, payload: any, id_work_time?: any) {
    const url = `${AppSettings.API_URI_V2}/tpv/refund/order/${id}/cash-register/${id_work_time}`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data;
      })
    )
  }
}
